import { useHotel } from './use-hotel.hook';

/**
 * The confirmation page expects the hotel parking information to be broken out separately to the other travel options.
 * @param hotelReferenceId
 * @returns Given hotel's parking transport option (or undefined if not loaded)
 */
export const useHotelParking = (hotelReferenceId: string | undefined) => {
  const hotel = useHotel(hotelReferenceId);

  return hotel?.location.transport.find((option) => option.mode === 'PARKING');
};
